let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8XFC9")).then(() => parcelRequire('gnNGp'));